import React, {  useEffect, useRef, useState } from 'react';
import './Home.css';
import { BrowserRouter ,  data,  useNavigate } from 'react-router-dom';
import {db,real_time_db,auth_app} from './firebase';
import { signInAnonymously } from 'firebase/auth';
import {
    collection,
    addDoc,
    onSnapshot,
    query,
    serverTimestamp,
    where,
    getDocs,
    or,
    updateDoc,
    doc} from "firebase/firestore";
import{
    onDisconnect,set,ref,onValue,
    update,serverTimestamp as rtdb_time} from "firebase/database";
function Home()
{
    const [info, setinfo] = useState([]);
    const [profile, change_profile] = useState('');
    const [index,change_index]=useState('');
    const [token,set_token]=useState(localStorage.getItem('token'));
    const [nameatfirst,set_nameatfirst]=useState('');
    const [all_nameatfirst,set_all_nameatfirst]=useState([]);
    const nav2=useNavigate();
    const [up_user,setup_user]=useState('');
    const [up_name,setup_name]=useState('');
    const [up_bio,setup_bio]=useState('');
    const [profile_section,set_profile_section]=useState('none');
    const [settings_section,set_settings_section]=useState('none');
    const [change_pass,set_change_pass]=useState(false);
    const [pass,setpass]=useState('');
    const [bgr,setbg]=useState('white')
    const [live_status,set_live_status]=useState('true')
    const [disp,setdisp]=useState("none")
    const [receiver,update_receiver]=useState('-');
    const [messages,setmessages]=useState([]);
    const [disp_chat,set_disp_chat]=useState("flex");
    const [indices,set_indices]=useState([]);
    const [innerwidth,set_innerwidth]=useState(window.innerWidth);
    const [status,set_status]=useState([]);
    const current_timeout=useRef(null)
    const [refreshed,set_refresh]=useState(false);
    const [loaded,set_loaded]=useState(false)
    const [flag1,set_flag1]=useState(false);
    const [unread,set_unread]=useState(0);
    const [edit_icon,set_edit]=useState('none')
    const [selectval,set_selectval]=useState('Select')
    const [msg_before_edit,set_msg_value]=useState('')
    const [reply_icon,set_reply]=useState('none')
    const [reply_to,set_reply_to]=useState('')
    const [msg_transfer,set_msg_transfer]=useState(0)
    const [search_value,set_search_value]=useState('')
    const [search_filter,set_search_filter]=useState([])
    const [no_match_msg,set_no_match_msg]=useState('none')
    const [innerheight,set_innerheight]=useState(window.innerHeight)
    const [verified,set_verified]=useState(false)
    const [chat_filter,set_chat_filter]=useState('all')
    const on_reload=useRef(false)
    const focus_input=useRef(false)
    const receiver_again=useRef('-');
    const [message_text,set_text]=useState('')
    const [msg_attributes,set_msg_attributes]=useState([])
    const sent_once=useRef([])
    const unseen_once=useRef([])
    const read_by_me_once=useRef([])
    const [dialog_value,set_dialog_value]=useState('')
    const dialogref=useRef(null);
    const [profile_pic,set_profile_pic]=useState('dp.png')
    const [profile_images,set_images]=useState([])
    const [updating_pic,set_updating_pic]=useState(false)
    const [consecutive_keys,set_consecutive_keys]=useState([])
    const [menu,set_menu]=useState('chat')
    const [main_body_section_width,set_main_body_section_width]=useState('')
    let w=-1;

    async function set_seen(user)
    {
        let entries=query(collection(db,'messages'),where("to","==",index),where("from","==",user),where("seen","==",false));
        let unseen=await getDocs(entries);
        for(let i=0;i<unseen.docs.length;i++)
        {
            await updateDoc(unseen.docs[i].ref,{seen:true,seenAt:serverTimestamp()})
        }
    } 

    function find_url(message)
    {
        const urlRegex = /(https?:\/\/[^\s]+)/g
        let portions=message.split(urlRegex)
        return portions.map((value,index)=>
        {
            if(urlRegex.test(value))
            {
                return(
                    <a style={{color:'lime',textDecoration:'none'}} key={index} href={value}>
                        {value}
                    </a>
                )
            }
            return value
        })
    }

    async function delete_msg(user,message)
    {
        if(message.startsWith('✔✔'))
        {
            let deleted_msgs=query(collection(db,'messages'),where("from","==",index),where("to","==",user),where("text","==",message.slice(message.indexOf(' ')+1,message.lastIndexOf(' ')-4)));
            let deleted=await getDocs(deleted_msgs)
            for(let i=0;i<deleted.docs.length;i++)
            {
                if(deleted.docs[i].data().createdAt.toDate().toISOString()===message.slice(message.lastIndexOf(' ')+1,message.length))
                {
                    await updateDoc(deleted.docs[i].ref,{delete:true})
                }
            }
            let deleted_replied_msgs1=query(collection(db,'messages'),where("replied_to",'==',message.replace(message.slice(0,message.indexOf(' ')),'✔') ));
            let deleted_replied1=await getDocs(deleted_replied_msgs1)
            if(deleted_replied1.docs.length>0)
            {
                for(let i=0;i<deleted_replied1.docs.length;i++)
                {
                    await updateDoc(deleted_replied1.docs[i].ref,{replied_to:`deleted ${deleted_replied1.docs[i].data().replied_to}`})
                }
            }
            let deleted_replied_msgs2=query(collection(db,'messages'),where("replied_to",'==',message.replace(message.slice(0,message.indexOf(' ')),'') ));
            let deleted_replied2=await getDocs(deleted_replied_msgs2)
            if(deleted_replied2.docs.length>0)
            {
                for(let i=0;i<deleted_replied2.docs.length;i++)
                {
                    await updateDoc(deleted_replied2.docs[i].ref,{replied_to:`deleted ${deleted_replied2.docs[i].data().replied_to}`})
                }
            }
            fetch('/delete_msg',
            {
                method:'POST',
                headers:{'Content-Type':'application/json'},
                body:JSON.stringify({from:index,to:user,message:message})
            })
            .then(responce=>responce.json())
        }
    }

    function reply_msg(user,message)
    {
        if(message.startsWith('✔✔') || message.startsWith(' '))
        {
            set_reply('flex');
            set_reply_to(message)
        }
    }

    function edit_msg(user,message)
    {
        if(message.startsWith('✔✔'))
        {
            set_text(message.slice(message.indexOf(' ')+1,message.lastIndexOf(' ')-4))
            set_edit('flex');
            set_msg_value(message)
            document.getElementById('Send_Button').style.backgroundColor='lime'
        }
    }
    
    async function write_edit(message)
    {
        set_edit('none')
        let intermediate=msg_before_edit
        set_msg_value('')
        let edit_this_msg=query(collection(db,'messages'),where("from","==",index),where("to","==",receiver),where("text","==",intermediate.slice(intermediate.indexOf(' ')+1,intermediate.lastIndexOf(' ')-4)));
        let edited_msgs=await getDocs(edit_this_msg)
        for(let i=0;i<edited_msgs.docs.length;i++)
        {
            if(edited_msgs.docs[i].data().createdAt.toDate().toISOString()===intermediate.slice(intermediate.lastIndexOf(' ')+1,intermediate.length))
            {
                await updateDoc(edited_msgs.docs[i].ref,{edit:true,text:message})
            }
        }
        let edit_replied1=query(collection(db,'messages'),where("replied_to","==",intermediate.replace(intermediate.slice(0,intermediate.indexOf(' ')),'✔')));
        let edited_replied_msgs1=await getDocs(edit_replied1)
        if(edited_replied_msgs1.docs.length>0)
        {
            for(let i=0;i<edited_replied_msgs1.docs.length;i++)
            {
                await updateDoc(edited_replied_msgs1.docs[i].ref,{replied_to:edited_replied_msgs1.docs[i].data().replied_to.replace(edited_replied_msgs1.docs[i].data().replied_to.slice(edited_replied_msgs1.docs[i].data().replied_to.indexOf(' ')+1,edited_replied_msgs1.docs[i].data().replied_to.lastIndexOf(' ')-4),message)})
            }
        }
        let edit_replied2=query(collection(db,'messages'),where("replied_to","==",intermediate.replace(intermediate.slice(0,intermediate.indexOf(' ')),'')));
        let edited_replied_msgs2=await getDocs(edit_replied2)
        if(edited_replied_msgs2.docs.length>0)
        {
            for(let i=0;i<edited_replied_msgs2.docs.length;i++)
            {
                await updateDoc(edited_replied_msgs2.docs[i].ref,{replied_to:edited_replied_msgs2.docs[i].data().replied_to.replace(edited_replied_msgs2.docs[i].data().replied_to.slice(edited_replied_msgs2.docs[i].data().replied_to.indexOf(' ')+1,edited_replied_msgs2.docs[i].data().replied_to.lastIndexOf(' ')-4),message)})
            }
        }
        fetch('/edit_message',
        {
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body:JSON.stringify({from:index,to:receiver,text:message,original_msg:intermediate})
        })
    }

    async function find_qouted_msg(message)
    {
        let qouted_msg=query(collection(db,'messages'),where("text","==",message.slice(message.indexOf(' ')+1,message.lastIndexOf(' ')-4)))
        let qouted_doc=await getDocs(qouted_msg)
        setmessages(prev=>
        {
            let previous=[...prev]
            let stop=false
            for(let i=0;i<qouted_doc.docs.length;i++)
            {    
                if(qouted_doc.docs[i].data().createdAt.toDate().toISOString()!==message.slice(message.lastIndexOf(' ')+1,message.length)){continue}
                for(let j=0;j<previous.length;j++)
                {
                    if(previous[j][0]===qouted_doc.docs[i].data().to || previous[j][0]===qouted_doc.docs[i].data().from)
                    {
                        for(let k=0;k<previous[j][1].length;k++)
                        {
                            if(previous[j][1][k].endsWith(qouted_doc.docs[i].data().replied_to.slice(qouted_doc.docs[i].data().replied_to.indexOf(' ')+1,qouted_doc.docs[i].data().replied_to.length)))
                            {
                                document.getElementsByClassName('chat_detail')[0].children[k].scrollIntoView({behavior:'smooth',block:'center'});
                                document.getElementsByClassName('chat_detail')[0].children[k].style.animation='none';
                                void document.getElementsByClassName('chat_detail')[0].children[k].offsetHeight;
                                document.getElementsByClassName('chat_detail')[0].children[k].style.animation='highlight 3s ease';
                                stop=true
                                break
                            }
                        }
                    }
                    if(stop){break}
                }
                if(stop){break}
            }
            return previous
        })
    }

    function update_data()
    {
        let ind=[]
        let accounts=[]
        let names=[]
        let images=[]
        fetch("/accounts",
        {
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body:JSON.stringify({test:'test'})
        })
        .then(responce=>responce.json())
        .then(data=>
        {
            for(let i=data.length-1;i>=0;i--)
            {
                if(data[i].name!==null || data[i].bio!==null)
                {
                    images.push(data[i].profilepicture===''?'dp.png':data[i].profilepicture)
                    ind.push(data[i].email)
                    accounts.push(data[i].name)
                    accounts.push(data[i].bio)
                    names.push(data[i].nameatfirst)
                }
            }
            set_images(images)
            set_all_nameatfirst(names)
            set_indices(ind)
            setinfo(accounts)
        })
    }

    function retrieve_messages(you)
    {
        fetch('/get_messages',
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email:you }),
        })
        .then(response => response.json())
        .then(data => 
        {
            if(data.error){}
            else{
                signInAnonymously(auth_app)
                .then(res=>set_verified(true))
                let frontend_messages=[]
                let feature_array=[]
                for(let i=0;i<data.length;i+=2)
                {
                    frontend_messages.push([data[i],data[i+1],0])
                }
                for(let i=0;i<frontend_messages.length;i++)
                { 
                    feature_array[i]=[]
                }
                set_msg_attributes(feature_array.map(arr=>[...arr]))
                setmessages(frontend_messages);
                set_refresh(true)
            }
        })
    }

    function update_info(up_user,up_name,up_bio)
    {        
        fetch('/save_info', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token:token, name: up_name,bio:up_bio }),
        })
        .then(response => response.json())
        .then(data =>
        {
            if(data.success===true)
            {
                change_profile(up_name)
                set_indices(prev=>
                {
                    let previous=[...prev]
                    let my_data=0
                    my_data=previous.indexOf(up_user)
                    setinfo(pre=>
                    {
                        let previous_again=[...pre]
                        previous_again[my_data*2]=up_name
                        previous_again[1+my_data*2]=up_bio
                        return previous_again
                    })
                    return previous
                })
                set_dialog_value(
                    <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
                      <label style={{fontWeight:'bold',color:'darkgreen'}}>Profile Saved</label>
                      <label>Profile details were saved.</label>
                      <button onClick={()=>
                        {
                            set_dialog_value('')
                            dialogref.current.close()
                        }}>Close</button>
                    </div>
                )
                dialogref.current.showModal();
            }
            else 
            {
                set_dialog_value(
                    <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
                      <label style={{fontWeight:'bold',color:'darkgreen'}}>Duplicate Name</label>
                      <label>This name is already taken!Choose Another.</label>
                      <button onClick={()=>
                        {
                            set_dialog_value('')
                            dialogref.current.close()
                        }}>Close</button>
                    </div>
                )
                dialogref.current.showModal();
            }
        });
    }
    
    function update_settings(pass,bg,nameatfirst,change_pass,live_status)
    {
        let online_status=ref(real_time_db,`online_status/${nameatfirst}`)
        update(online_status,{display:live_status})
        fetch('/save_settings', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token: token,change:change_pass==='true'?true:false, password: pass, bg: bg }),
        })
        .then(response => response.json())
        .then(data=>
        {
            if(data.success)
            {
                if(data.new_token){
                    localStorage.setItem('token',data.new_token)
                    set_token(data.new_token)
                }
                set_dialog_value('')
                set_dialog_value(
                    <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
                      <label style={{fontWeight:'bold',color:'darkgreen'}}>Settings Saved</label>
                      <label>Account Settings were saved.</label>
                      <button onClick={()=>
                        {
                            set_dialog_value('')
                            dialogref.current.close()
                        }}>Close</button>
                    </div>
                )
                dialogref.current.showModal();
            }
            else{
                set_dialog_value('')
                set_dialog_value(
                    <div style={{display:'flex',flexDirection:'column',gap:'10px'}}>
                      <label style={{fontWeight:'bold',color:'darkgreen'}}>Empty Password</label>
                      <label>Password cannot be empty.</label>
                      <button onClick={()=>
                        {
                            set_dialog_value('')
                            dialogref.current.close()
                        }}>Close</button>
                    </div>
                )
                dialogref.current.showModal();
            }
        }
        )
    }

    function typing_status()
    {
        let online_status=ref(real_time_db,`online_status/${nameatfirst}`);
        update(online_status,{
            typing:true,
            recipient:receiver
        })
        if(current_timeout.current)
        {
            clearTimeout(current_timeout.current)
        }
        current_timeout.current=setTimeout(()=>
        {
            update(online_status,{
                typing:false,
                recipient:''
            })
        },2000)
    }

    useEffect(()=>
    {
        if(!nameatfirst || !index || all_nameatfirst.includes(nameatfirst)===false || !verified){return;}
        let online_status=ref(real_time_db,`online_status/${nameatfirst}`);
        let disconnect=onDisconnect(online_status)
        update(online_status,{
            online:true,
            lastseen:rtdb_time()
        })
        onDisconnect(online_status).update(
        {
            online:false,
            lastseen:rtdb_time()
        }
        )
        let online_users=ref(real_time_db,'/online_status')
        let current_status=onValue(online_users,(snapshot)=>
        {
            let active_users=snapshot.val()
            let statuses=[]
            for(let i=0;i<all_nameatfirst.length;i++)
            {
                if(all_nameatfirst[i]===nameatfirst)
                {
                    set_live_status(!active_users[all_nameatfirst[i]].display?'true':active_users[all_nameatfirst[i]].display)
                }
                if(Object.keys(active_users).includes(all_nameatfirst[i] ))
                {
                    if(active_users[all_nameatfirst[i]].display==='false'){statuses.push('')}
                    else if(active_users[all_nameatfirst[i]].online)
                    {
                        if(active_users[all_nameatfirst[i]].typing && active_users[all_nameatfirst[i]].recipient===index)
                        {
                            statuses.push('(Typing...)')
                        }
                        else{
                            statuses.push('(Online)')
                        }
                    }
                    else if(active_users[all_nameatfirst[i]].lastseen && active_users[all_nameatfirst[i]].online==false){
                        statuses.push('Active '+'('+(new Date(active_users[all_nameatfirst[i]].lastseen).toLocaleDateString()
                        ===new Date().toLocaleDateString()?new Date(active_users[all_nameatfirst[i]].lastseen).toLocaleTimeString():
                        new Date(active_users[all_nameatfirst[i]].lastseen).toLocaleDateString())+')')
                    }
                }
                else{statuses.push('')}
            }
            set_status(statuses)
        })
        return()=> 
        {
            update(online_status,{
                online:false,
                lastseen:rtdb_time()
            })
            current_status()
        }
    },[nameatfirst,all_nameatfirst,verified,index])

    useEffect(()=>
    {
        if( !index || indices.includes(index)===false || !refreshed || !verified ){return;}
        let action_query=query(collection(db,'messages'),or(where('from','==',index),where('to','==',index)));
        let action=onSnapshot(action_query,(snapshot)=>
        {
            console.log(on_reload.current)
            if(!on_reload.current)sent_once.current=snapshot.docs.map(doc => doc.id)
            let sent_messages=snapshot.docChanges().filter(change=>(change.doc.data().from===index? change.type==='added':change.type==='modified' && change.doc.data().neondb) && on_reload.current).map(function(change)
            {
                return {id:change.doc.id,...change.doc.data()}
            })
            let delivered_messages=snapshot.docChanges().filter(change=>(change.doc.data().to===index || change.doc.data().from===index) && change.doc.data().neondb && on_reload.current).map(function(change)
            {
                return {id:change.doc.id,...change.doc.data()}
            })
            let edited_messages=snapshot.docChanges().filter(change=>change.doc.data().edit && !change.doc.data().delete ).map(function(change)
            {
                return {id:change.doc.id,...change.doc.data()}
            })
            let unseen_messages=snapshot.docChanges().filter(change=>!change.doc.data().seen && change.doc.data().to===index && !change.doc.data().delete && change.doc.data().neondb).map(function(change)
            {
                return {id:change.doc.id,...change.doc.data()}
            })
            let read_by_me_messages=snapshot.docChanges().filter(change=>change.doc.data().seen && change.doc.data().to===index && !change.doc.data().delete && change.doc.data().neondb).map(function(change)
            {
                return {id:change.doc.id,...change.doc.data()}
            })
            if(!on_reload.current)read_by_me_once.current=snapshot.docs.map(doc => doc.id && doc.data().seen && doc.data().to===index && doc.data().neondb)
            if(!on_reload.current)unseen_once.current=snapshot.docs.map(doc => doc.id && !doc.data().seen && doc.data().to===index && doc.data().neondb)
            let read_messages=snapshot.docChanges().filter(change=>change.doc.data().neondb && change.doc.data().seen && change.doc.data().from===index && !change.doc.data().delete).map(function(change)
            {
                return {id:change.doc.id,...change.doc.data()}
            })
            let replied_messages=snapshot.docChanges().filter(change=>  change.doc.data().reply && !change.doc.data().delete).map(function(change)
            {
                return {id:change.doc.id,...change.doc.data()} 
            })
            let deleted_messages=snapshot.docChanges().filter(change=> change.doc.data().delete || (!on_reload.current?!change.doc.data().neondb:0)).map(function(change)
            {
                return {id:change.doc.id,...change.doc.data()}
            })
            if(sent_messages.length>0 && !sent_once.current.includes(sent_messages[0].id))
            {
                sent_once.current.push(sent_messages[0].id)
                let to=sent_messages[0].to;
                let from=sent_messages[0].from;
                let message_text=sent_messages[0].text;
                let time=sent_messages[0].client_time; 
                setmessages(prev=>
                {
                    let previous=[...prev]
                    let found=0
                    for(let i=0;i<previous.length;i++)
                    {
                        if(to===from)
                        {
                            if(previous[i][0]===index)
                            {
                                found=1
                                previous[i][1].push(`✔ ${message_text}     ${time}`);
                                let inter=previous[i]
                                previous.splice(i,1)
                                previous.unshift(inter);
                                set_msg_attributes(pre_attributes=>
                                {
                                    let previous_attributes=[...pre_attributes]
                                    let spliced_element=previous_attributes[i]
                                    previous_attributes.splice(i,1)
                                    previous_attributes.unshift(spliced_element)
                                    return previous_attributes
                                })
                                if(sent_messages[0].reply===true)
                                {
                                    set_msg_attributes(pre_attributes=>
                                    {
                                        let previous_attributes=[...pre_attributes]
                                        if(!previous_attributes[0][previous[0][1].indexOf(`✔ ${message_text}     ${time}`)])
                                        {previous_attributes[0][previous[0][1].indexOf(`✔ ${message_text}     ${time}`)]={}}
                                        previous_attributes[0][previous[0][1].indexOf(`✔ ${message_text}     ${time}`)].reply_info=['flex','You',sent_messages[0].replied_to.slice(sent_messages[0].replied_to.indexOf(' ')+1,sent_messages[0].replied_to.lastIndexOf(' ')-4)]
                                        return previous_attributes
                                    })
                                }
                                return previous;
                            }
                        }
                        else{
                            if(from==index && previous[i][0]==to)
                            {
                                found=1
                                previous[i][1].push(`✔ ${message_text}     ${time}`)
                                let inter=previous[i]
                                previous.splice(i,1)
                                previous.unshift(inter);
                                set_msg_attributes(pre_attributes=>
                                {
                                    let previous_attributes=[...pre_attributes]
                                    let spliced_element=previous_attributes[i]
                                    previous_attributes.splice(i,1)
                                    previous_attributes.unshift(spliced_element)
                                    return previous_attributes
                                })
                                if(sent_messages[0].reply===true)
                                {
                                    set_msg_attributes(pre_attributes=>
                                    {
                                        let previous_attributes=[...pre_attributes]
                                        if(!previous_attributes[0][previous[0][1].indexOf(`✔ ${message_text}     ${time}`)])
                                        {previous_attributes[0][previous[0][1].indexOf(`✔ ${message_text}     ${time}`)]={}}
                                        previous_attributes[0][previous[0][1].indexOf(`✔ ${message_text}     ${time}`)].reply_info=['flex',sent_messages[0].replied_to.startsWith('✔')?'You':info[indices.indexOf(sent_messages[0].to)*2],sent_messages[0].replied_to.slice(sent_messages[0].replied_to.indexOf(' ')+1,sent_messages[0].replied_to.lastIndexOf(' ')-4)]
                                        return previous_attributes
                                    })
                                }
                                return previous;
                            } 
                            else if(to==index && previous[i][0]==from){
                                found=1
                                previous[i][1].push(` ${message_text}     ${time}`)
                                let inter=previous[i]
                                previous.splice(i,1)
                                previous.unshift(inter);
                                set_msg_attributes(pre_attributes=>
                                {
                                    let previous_attributes=[...pre_attributes]
                                    let spliced_element=previous_attributes[i]
                                    previous_attributes.splice(i,1)
                                    previous_attributes.unshift(spliced_element)
                                    return previous_attributes
                                })
                                return previous;
                            }
                        }
                    }
                    if(found==0)
                    {
                        if(to==from){previous.unshift([from,[`✔ ${message_text}     ${time}`]]);}
                        else if(from==index){previous.unshift([to,[`✔ ${message_text}     ${time}`]]);}
                        else if(to==index){
                            update_data()
                            previous.unshift([from,[` ${message_text}     ${time}`]]);
                        }
                        set_msg_attributes(pre_attributes=>
                        {
                            let previous_attributes=[...pre_attributes]
                            previous_attributes.unshift([])
                            return previous_attributes
                        })
                        return previous;
                    }
                });  
                set_msg_transfer(prev=>prev+1)
            }
            setmessages(prev=>
            {
                let previous=[...prev]
                if(delivered_messages.length>0)
                {
                    let receiver_index=previous.findIndex(x=>x[0]===delivered_messages[0].from===index?delivered_messages[0].to:delivered_messages[0].from)
                    let message_index=previous[receiver_index][1].findIndex(x=>x===`${delivered_messages[0].from===index?'✔':''} ${delivered_messages[0].text}     ${delivered_messages[0].client_time}` )
                    if(message_index!==-1)previous[receiver_index][1][message_index]=`${delivered_messages[0].from===index?'✔✔':''} ${delivered_messages[0].text}     ${delivered_messages[0].createdAt.toDate().toISOString()}`
                }
                for(let i=0;i<edited_messages.length;i++)
                {
                    let stop=false
                    for(let j=0;j<previous.length;j++)
                    {
                        if(previous[j][0]===edited_messages[i].to || previous[j][0]===edited_messages[i].from )
                        {
                            for(let k=0;k<previous[j][1].length;k++)
                            {
                                if(edited_messages[i].createdAt.toDate().toISOString()===previous[j][1][k].slice(previous[j][1][k].lastIndexOf(' ')+1,previous[j][1][k].length))
                                {
                                    previous[j][1][k]=previous[j][1][k].replace(previous[j][1][k].slice(previous[j][1][k].indexOf(' ')+1,previous[j][1][k].lastIndexOf(' ')-4),edited_messages[i].text)
                                    set_msg_attributes(pre_attributes=>
                                    {
                                        let previous_attributes=[...pre_attributes]
                                        if(!previous_attributes[j][k]){previous_attributes[j][k]={}}
                                        previous_attributes[j][k].edit_info='Edited'
                                        return previous_attributes
                                    })
                                    stop=true
                                    break
                                }
                            }
                        }
                        if(stop){break}
                    }
                }
                for(let i=0;i<unseen_messages.length;i++)
                {
                    if(!unseen_once.current.includes(unseen_messages[i].id))
                    {
                        unseen_once.current.push(unseen_messages[i].id)
                        let stop=false
                        for(let j=0;j<previous.length;j++)                    
                        {
                            if(previous[j][0]===unseen_messages[i].from)
                            {
                                for(let k=0;k<previous[j][1].length;k++)
                                {
                                    if(unseen_messages[i].createdAt.toDate().toISOString()===previous[j][1][k].slice(previous[j][1][k].lastIndexOf(' ')+1,previous[j][1][k].length))
                                    {
                                        console.log(unseen_messages[i])
                                        console.log(on_reload.current)
                                        if(!on_reload.current)
                                        {
                                            previous[j][2]=previous[j][2]===undefined?0:previous[j][2]
                                            previous[j][2]+=1
                                        }
                                        else{
                                            if(receiver_again.current!==unseen_messages[i].from)
                                            {
                                                previous[j][2]=previous[j][2]===undefined?0:previous[j][2]
                                                previous[j][2]+=1
                                            }
                                            else{
                                                let msgref=doc(db,'messages',unseen_messages[i].id)
                                                updateDoc(msgref,{seen:true,seenAt:serverTimestamp()})
                                            }
                                        }
                                        stop=true
                                        break
                                    }
                                }
                            } 
                            if(stop){break}
                        }
                    }
                }
                if(on_reload.current)
                {
                    for(let i=0;i<read_by_me_messages.length;i++)
                    {
                        if(!read_by_me_once.current.includes(read_by_me_messages[i].id))
                        {
                            read_by_me_once.current.push(read_by_me_messages[i].id)
                            let other_person_index=previous.findIndex(x=>x[0]===read_by_me_messages[i].from)
                            if(other_person_index!==-1 && previous[other_person_index][2]>0)previous[other_person_index][2]-=1
                        }
                    }
                }
                let unread_chats=0
                for(let i=0;i<previous.length;i++)
                {
                    previous[i][2]=previous[i][2]===undefined?0:previous[i][2]
                    if(previous[i][2]>0){unread_chats+=1}
                }
                set_unread(unread_chats)
                for(let i=0;i<read_messages.length;i++)
                {
                    let stop=false
                    for(let j=0;j<previous.length;j++)
                    {
                        if(previous[j][0]=== read_messages[i].to && read_messages[i].createdAt!==null)
                        {
                            for(let k=0;k<previous[j][1].length;k++)
                            {
                                if(read_messages[i].createdAt.toDate().toISOString()===previous[j][1][k].slice(previous[j][1][k].lastIndexOf(" ")+1,previous[j][1][k].length))
                                {
                                    previous[j][1][k]=`✔✔${previous[j][1][k]}`
                                    set_msg_attributes(pre_attributes=>
                                    {
                                        let previous_attributes=[...pre_attributes]
                                        if(!previous_attributes[j][k]){previous_attributes[j][k]={}}
                                        previous_attributes[j][k].seen_info=new Date(read_messages[i].seenAt.toDate().toISOString()).getDate()===new Date().getDate()?"Seen"+' '+':'+' '+new Date(read_messages[i].seenAt.toDate().toISOString()).toLocaleTimeString():"Seen"+' '+':'+' '+new Date(read_messages[i].seenAt.toDate().toISOString()).toLocaleDateString()
                                        return previous_attributes
                                    })
                                    stop=true
                                    break
                                }
                            } 
                        }   
                        if(stop){break}
                    }
                }
                for(let i=0;i<replied_messages.length;i++)
                {
                    let stop=false
                    for(let j=0;j<previous.length;j++)
                    {
                        if((previous[j][0]===replied_messages[i].to || previous[j][0]===replied_messages[i].from) &&  replied_messages[i].replied_to.startsWith('d')===false)
                        {
                            for(let k=0;k<previous[j][1].length;k++)
                            {
                                if(replied_messages[i].createdAt!==null  && replied_messages[i].createdAt.toDate().toISOString()===previous[j][1][k].slice(previous[j][1][k].lastIndexOf(' ')+1,previous[j][1][k].length))
                                {
                                    if(previous[j][1][k].startsWith('✔'))
                                    {
                                        set_msg_attributes(pre_attributes=>
                                        {
                                            let previous_attributes=[...pre_attributes]
                                            if(!previous_attributes[j][k]){previous_attributes[j][k]={}}
                                            previous_attributes[j][k].reply_info=['flex',replied_messages[i].replied_to.startsWith('✔')?'You':info[indices.indexOf(replied_messages[i].to)*2],replied_messages[i].replied_to.slice(replied_messages[i].replied_to.indexOf(' ')+1,replied_messages[i].replied_to.lastIndexOf(' ')-4)]
                                            return previous_attributes
                                        })
                                    }
                                    else if(previous[j][1][k].startsWith(' '))
                                    {
                                        set_msg_attributes(pre_attributes=>
                                        {
                                            let previous_attributes=[...pre_attributes]
                                            if(!previous_attributes[j][k]){previous_attributes[j][k]={}}
                                            previous_attributes[j][k].reply_info=['flex',replied_messages[i].replied_to.startsWith('✔')?info[indices.indexOf(replied_messages[i].from)*2]:'You',replied_messages[i].replied_to.slice(replied_messages[i].replied_to.indexOf(' ')+1,replied_messages[i].replied_to.lastIndexOf(' ')-4)]
                                            return previous_attributes
                                        })
                                    }
                                    stop=true
                                    break
                                }
                            }
                        }
                        else if(replied_messages[i].replied_to.startsWith('d'))
                        {
                            for(let k=0;k<previous[j][1].length;k++)
                            {
                                if(replied_messages[i].createdAt!==null  && replied_messages[i].createdAt.toDate().toISOString()===previous[j][1][k].slice(previous[j][1][k].lastIndexOf(' ')+1,previous[j][1][k].length))
                                {
                                    set_msg_attributes(pre_attributes=>
                                    {
                                        let previous_attributes=[...pre_attributes]
                                        if(!previous_attributes[j][k]){previous_attributes[j][k]={}}
                                        previous_attributes[j][k].reply_info=['none','','']
                                        return previous_attributes
                                    })
                                    stop=true
                                    break
                                }
                            }
                        }
                        if(stop){break}
                    }
                }
                let remove_elements=0
                for(let i=0;i<deleted_messages.length;i++)
                {
                    let stop=false
                    for(let j=0;j<previous.length;j++)
                    {
                        if(previous[j][0]===deleted_messages[i].from || previous[j][0]===deleted_messages[i].to)
                        {
                            for(let k=0;k<previous[j][1].length;k++)
                            {
                                if(deleted_messages[i].createdAt.toDate().toISOString()===previous[j][1][k].slice(previous[j][1][k].lastIndexOf(' ')+1,previous[j][1][k].length))
                                {
                                    if(previous[j][1][k-1]!=undefined)
                                    {
                                        if(!previous[j][1][k-1].startsWith('✔') && !previous[j][1][k-1].startsWith(' '))
                                        {
                                            if(!previous[j][1][k+1] || (!previous[j][1][k+1].startsWith('✔') && !previous[j][1][k+1].startsWith(' ')))
                                            {remove_elements=2
                                            previous[j][1].splice(k-1,2)}
                                            else{remove_elements=1;previous[j][1].splice(k,1)}
                                        }
                                        else{remove_elements=1;previous[j][1].splice(k,1)}
                                    }
                                    
                                    set_msg_attributes(pre_attributes=>
                                    {
                                        let previous_attributes=[...pre_attributes]
                                        if(remove_elements===1){pre_attributes[j].splice(k,1)};if(remove_elements===2){pre_attributes[j].splice(k-1,1)}
                                        return previous_attributes
                                    })
                                    if(previous[j][1].length===0)
                                    {   
                                        previous.splice(j,1)
                                        set_msg_attributes(pre_attributes=>
                                        {
                                            let previous_attributes=[...pre_attributes]
                                            previous_attributes.splice(j,1)
                                            return previous_attributes
                                        })
                                    }
                                    stop=true
                                    break
                                }
                            }
                        }
                        if(stop){break}
                    }
                }
                if(!on_reload.current || remove_elements>0)
                {
                    let friends=previous.map(x=>x[0])
                    previous.sort((a,b)=>
                    {
                        return new Date(b[1][b[1].length-1].slice(b[1][b[1].length-1].lastIndexOf(' ')+1,b[1][b[1].length-1].length))-
                        new Date(a[1][a[1].length-1].slice(a[1][a[1].length-1].lastIndexOf(' ')+1,a[1][a[1].length-1].length))
                    })
                    let friends_updated=previous.map(x=>x[0])
                    set_msg_attributes(pre_attributes=>
                    {
                        let previous_attributes=[...pre_attributes]
                        for(let i=0;i<friends.length;i++)
                        {
                            if(friends[i]!==friends_updated[i])
                            {
                                let a=previous_attributes[i]
                                let b=friends.indexOf(friends_updated[i])
                                previous_attributes[i]=previous_attributes[b]
                                previous_attributes[b]=a
                                let temp=friends[i]
                                friends[i]=friends_updated[i]
                                friends[b]=temp
                            }
                        }
                        return previous_attributes
                    })
                }
                console.log(previous)
                if(!on_reload.current){set_msg_transfer(pre_value=>pre_value+1);on_reload.current=true}
                return previous
            })
            if(flag1===true){set_loaded(true);}
        })
        return()=>
        {
            action()
        }
    },[indices,index,refreshed,verified])

    useEffect(() => {
        if(window.innerWidth<=1100){
            if(menu!=='people')
            {
                document.getElementsByClassName('people_section')[0].style.flex=0;
            }
            else
            {document.getElementsByClassName('people_section')[0].style.flex=1;document.getElementsByClassName('main_body_section')[0].style.flex=0;}    
        }
        else{
            document.getElementsByClassName('people_section')[0].style.display='flex';
            document.getElementsByClassName('people_section')[0].style.flex=0.5;
            document.getElementsByClassName('main_body_section')[0].style.flex=1;
            document.getElementsByClassName('main_body_section')[0].style.display='flex';
        }
    },[innerwidth,menu])

    useEffect(()=>
    {
        if(document.getElementsByClassName('main_body_section')[0])
        {
            set_main_body_section_width(parseFloat( getComputedStyle(document.getElementsByClassName('main_body_section')[0]).width))
        }
        let body_section=document.querySelector('.body_section')
        let main_body_section=document.querySelector('.main_body_section')
        let people_section=document.querySelector('.people_section')
        if(innerwidth<=1100 && innerwidth>500){body_section.style.height=(window.innerHeight)+'px';main_body_section.style.height=(window.innerHeight)+'px';}
        else if(innerwidth<=500){body_section.style.height=(window.innerHeight)+'px';main_body_section.style.height=(window.innerHeight)+'px';}
        else if(innerwidth>1100){body_section.style.height=(window.innerHeight)+'px';main_body_section.style.height=(window.innerHeight)+'px';}
    },[innerheight,innerwidth])

    useEffect(() => {
        let container=document.getElementsByClassName('chat_detail_section');
        if(container.length>0){container[0].scrollTop = container[0].scrollHeight;}
        set_text('')
        document.getElementById('message').style.height='46px'
        document.getElementById('Send_Button').style.backgroundColor='#EEEEEE'
        document.getElementsByClassName('chat_detail_section')[0].style.marginBottom='70px'
        focus_input.current.focus()
        set_edit('none')
        set_msg_value('')
        set_reply('none')
        set_reply_to('')
    },[receiver])

    useEffect(()=>
    {
        if(parseInt(getComputedStyle(document.getElementById('message')).height)<50)
        {
            document.getElementsByClassName('chat_detail_section')[0].style.marginBottom=70+(msg_before_edit.length>0 || reply_to.length>0?46:0)+'px'
        }
        else if(parseInt(getComputedStyle(document.getElementById('message')).height)>50 && parseInt(getComputedStyle(document.getElementById('message')).height)<70)
        {
            document.getElementsByClassName('chat_detail_section')[0].style.marginBottom=88+(msg_before_edit.length>0 || reply_to.length>0?46:0)+'px'
        }
        else{
            document.getElementsByClassName('chat_detail_section')[0].style.marginBottom=106+(msg_before_edit.length>0 || reply_to.length>0?46:0)+'px'
        }
    },[reply_to,msg_before_edit,message_text])

    useEffect(()=>
    {
        if(!msg_transfer || !refreshed){return}
        setmessages(prev=>
        {
            let previous=[...prev]
            let days=['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday']
            let months=['January','February','March','April','May','June','July','August','September','October','November','December']
            for(let i=0;i<previous.length;i++)
            {
                for(let j=0;j<previous[i][1].length;j++)
                {
                    if(previous[i][1][j].startsWith(' ') || previous[i][1][j].startsWith('✔'))
                    {
                        let present_date=new Date(previous[i][1][j].slice(previous[i][1][j].lastIndexOf(' ')+1,previous[i][1][j].length)).toLocaleDateString()
                        if(present_date!==String(new Date().toLocaleDateString()))
                        {
                            if(new Date(previous[i][1][j].slice(previous[i][1][j].lastIndexOf(' ')+1,previous[i][1][j].length)).getMonth()===new Date().getMonth() && new Date(previous[i][1][j].slice(previous[i][1][j].lastIndexOf(' ')+1,previous[i][1][j].length)).getFullYear()===new Date().getFullYear())
                            {
                                let difference=new Date().getDate()-new Date(previous[i][1][j].slice(previous[i][1][j].lastIndexOf(' ')+1,previous[i][1][j].length)).getDate()
                                if(difference===1){present_date='Yesterday'}
                                else if(difference<7)
                                {
                                    present_date=days[new Date(previous[i][1][j].slice(previous[i][1][j].lastIndexOf(' ')+1,previous[i][1][j].length)).getDay()]
                                }
                                else{
                                present_date=`${months[new Date(previous[i][1][j].slice(previous[i][1][j].lastIndexOf(' ')+1,previous[i][1][j].length)).getMonth()]} ${new Date(previous[i][1][j].slice(previous[i][1][j].lastIndexOf(' ')+1,previous[i][1][j].length)).getDate()}, ${new Date(previous[i][1][j].slice(previous[i][1][j].lastIndexOf(' ')+1,previous[i][1][j].length)).getFullYear()}`
                                }
                            }
                            else
                            {
                                present_date=`${months[new Date(previous[i][1][j].slice(previous[i][1][j].lastIndexOf(' ')+1,previous[i][1][j].length)).getMonth()]} ${new Date(previous[i][1][j].slice(previous[i][1][j].lastIndexOf(' ')+1,previous[i][1][j].length)).getDate()}, ${new Date(previous[i][1][j].slice(previous[i][1][j].lastIndexOf(' ')+1,previous[i][1][j].length)).getFullYear()}`
                            }
                        }
                        else{present_date='Today'}
                        if(previous[i][1].includes(present_date)===false)
                        {
                            previous[i][1].splice(j,0,present_date)
                            set_msg_attributes(pre_attributes=>
                            {
                                let previous_attributes=[...pre_attributes]
                                previous_attributes[i].splice(j,0,present_date)
                                return previous_attributes
                            })
                        }
                    }
                }
                if(msg_transfer>1)
                {
                    if(receiver_again.current===previous[0][0])
                    {document.getElementsByClassName('chat_detail')[0].children[document.getElementsByClassName('chat_detail')[0].children.length-1].scrollIntoView({behavior:'smooth'})}
                    break
                }
            }
            return previous
        })
    },[msg_transfer,refreshed])

    useEffect(() => {
        if(!localStorage.getItem('logged_in')){nav2('/')}
        window.addEventListener('resize',()=>
        {
            set_innerwidth(window.innerWidth);
            set_innerheight(window.innerHeight);
        })
        fetch('/user_data',{
            method:'POST',
            headers:{
                'Content-Type':'application/json'
            },
            body:JSON.stringify({token:token})
        })
        .then(response => response.json())
        .then(data=>
        {
            let flag=[false,null]
            if(data.result[0]?.token===token)
            {
                change_profile(data.result[0].name)
                change_index(data.result[0].email)
                set_nameatfirst(data.result[0].nameatfirst)
                set_profile_pic(data.result[0].profilepicture===''?'dp.png':data.result[0].profilepicture)
                retrieve_messages(data.result[0].email)
                flag=[true,data.result[0].name]
                set_flag1(true)
                setup_user(data.result[0].email);
                setup_name(data.result[0].name);
                setup_bio(data.result[0].bio);
                setpass('');
                setbg(data.result[0].bg);
            }
            if(flag[0]===false){set_flag1(false);set_loaded(false);localStorage.removeItem('logged_in');nav2('/');}
            else if(flag[1]===null || flag[1]===undefined){set_flag1(false);set_loaded(false);nav2('/profile')}
        }
        )
        fetch("/accounts",
        {
            method:'POST',
            headers:{'Content-Type':'application/json'},
            body:JSON.stringify({test:'test'})
        })
        .then(response => response.json())
        .then(data => 
        {
            let ind=[]
            let accounts=[] 
            let images=[]
            let names=[]
            for(let i=data.length-1;i>=0;i--)
            {
                if(data[i].name!==null || data[i].bio!==null)
                {
                    accounts.push(data[i].name);
                    accounts.push(data[i].bio);
                    ind.push(data[i].email)
                    names.push(data[i].nameatfirst)
                    images.push(data[i].profilepicture===''?'dp.png':data[i].profilepicture)
                }
            }
            set_images(images)
            set_all_nameatfirst(names)
            set_indices(ind);
            setinfo(accounts);
        });
        let icons=document.querySelectorAll(".desktop_icons label");
        let refresh_people=document.getElementById("refresh_people");
        refresh_people.addEventListener("click",function()
        {
            fetch("/accounts",
            {
                method:'POST',
                headers:{'Content-Type':'application/json'},
                body:JSON.stringify({test:'test'})
            })
            .then(response => response.json())
            .then(data => 
            {
                let accounts=[]
                let ind=[]
                let names=[]
                let images=[]
                for(let i=data.length-1;i>=0;i--)
                {
                    if(data[i].name && data[i].bio)
                    {
                        accounts.push(data[i].name);
                        accounts.push(data[i].bio);
                        ind.push(data[i].email)
                        names.push(data[i].nameatfirst)
                        images.push(data[i].profilepicture===''?'dp.png':data[i].profilepicture)
                    }
                }
                set_images(images)
                set_all_nameatfirst(names)
                set_indices(ind);
                setinfo(accounts);
            })
        })
        let phone_icons=document.querySelectorAll(".phone_icons label");
        for(let i=0;i<phone_icons.length;i++)
        {
            phone_icons[i].addEventListener('click',()=>{
            update_receiver('-')
            receiver_again.current='-'
            if(i==0){set_profile_section('none');set_settings_section('none');setdisp('none');set_disp_chat('flex');document.getElementsByClassName('people_section')[0].style.display='none';document.getElementsByClassName('people_section')[0].style.flex=0;document.getElementsByClassName('main_body_section')[0].style.flex=1}
            if(i==1){set_profile_section('flex');set_settings_section('none');setdisp('none');set_disp_chat('none');document.getElementsByClassName('people_section')[0].style.display='none';document.getElementsByClassName('people_section')[0].style.flex=0;document.getElementsByClassName('main_body_section')[0].style.flex=1}
            if(i==2){set_profile_section('none');set_settings_section('flex');setdisp('none');set_disp_chat('none');document.getElementsByClassName('people_section')[0].style.display='none';document.getElementsByClassName('people_section')[0].style.flex=0;document.getElementsByClassName('main_body_section')[0].style.flex=1}
            if(i==3){set_profile_section('none');set_settings_section('none');setdisp('none');set_disp_chat('none');document.getElementsByClassName('people_section')[0].style.display='flex';document.getElementsByClassName('people_section')[0].style.flex=1;document.getElementsByClassName('main_body_section')[0].style.flex=0}
            });
        }
        for(let i=0;i<icons.length;i++)
        {
            icons[i].addEventListener('click',()=>{
                update_receiver('-')
                receiver_again.current='-'
                if(i==0){set_profile_section('none');set_settings_section('none');setdisp('none');set_disp_chat('flex')}
                if(i==1){set_profile_section('flex');set_settings_section('none');setdisp('none');set_disp_chat('none')}
                if(i==2){set_profile_section('none');set_settings_section('flex');setdisp('none');set_disp_chat('none')}
            });
        }
    }, []);
    
    async function Send(message)
    {
        let ids=[]
        let msg_being_replied=""
        if(reply_icon==='flex')
        {
            set_reply('none')
            msg_being_replied=reply_to
            set_reply_to('')
        }
        let inserted_msg=await addDoc(collection(db,'messages'),{
            from: index,
            to: receiver,
            text: message,
            seen:index===receiver?true:false,
            createdAt: serverTimestamp(),
            seenAt:index===receiver?serverTimestamp():null,
            replied_to:msg_being_replied.startsWith('✔')? msg_being_replied.replace(msg_being_replied.slice(0,msg_being_replied.indexOf(' ')),'✔'):msg_being_replied.startsWith(' ')?msg_being_replied:'',
            reply: msg_being_replied===''?false:true,
            client_time: new Date().toISOString()
        });
        onSnapshot(inserted_msg,(message_document)=>
        {
            let data=message_document.data()
            if(data!==undefined)
            {
                if(!data.createdAt){return}
                else
                {
                    if(ids.includes(message_document.id)===false)
                    {
                        ids.push(message_document.id)
                        fetch('/save_msg',
                        {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({ from: index, to: receiver, message: message,time:data.createdAt.toDate().toISOString()}),
                        })
                        .then(response => response.json())
                        .then( async data_neon=>
                        {   
                            if(data_neon.success)
                            {
                                await updateDoc(inserted_msg,{neondb:true})
                            }
                        })
                    }
                }
            }
        })    
    }

    useEffect(() => {
        let connect_buttons=document.getElementsByClassName("connect_buttons");
        for(let i=0;i<connect_buttons.length;i++)
        {
            connect_buttons[i].addEventListener('click',()=>{
                if(window.innerWidth<=1100){document.getElementsByClassName('people_section')[0].style.flex=0;document.getElementsByClassName('main_body_section')[0].style.flex=1}
                else{document.getElementsByClassName('people_section')[0].style.flex=0.5;document.getElementsByClassName('main_body_section')[0].style.flex=1}
                setdisp("flex");
                set_profile_section('none');
                set_settings_section('none');
                set_disp_chat('none');
            });
        }
    }, [info]);

    useEffect(()=>
    {
        let values=[]
        if(search_value!=='')
        {
            for(let i=0;i<info.length;i+=2)
            {
                if(info[i].toLowerCase().startsWith(search_value.toLowerCase()))
                {
                    values[i/2]='flex'
                }
                else{values[i/2]='none'}
            }
            let found_result=false
            values.forEach(x=>
            {
                if(x==='flex'){found_result=true;return}
            })
            if(found_result){set_no_match_msg('none')}
            else{set_no_match_msg('flex')}
        }
        else if(search_value==='')
        {
            for(let i=0;i<info.length;i+=2)
            {
                values[i/2]='flex'
            }
            set_no_match_msg('none')
        }
        set_search_filter(values)
    },[search_value,info])

    useEffect(()=>
    {
        document.addEventListener('click',(e)=>
        {
            if(e.target.tagName==='IMG' && e.target.src.slice(e.target.src.lastIndexOf('/')+1,e.target.src.length)!=='dp.png')
            {
                set_dialog_value(
                    <img style={{width:'280px',height:'280px',objectFit:'cover',flexShrink:'0'}} src={e.target.src}></img>
                )
                dialogref.current.showModal()
                document.getElementsByTagName('dialog')[0].style.scrollbarWidth='none'
            }
            else{
                if(dialogref.current?.open && document.getElementsByTagName('dialog')[0].innerHTML.startsWith('<img'))
                {
                    set_dialog_value('')
                    dialogref.current.close()
                }
            }
            if(e.target.id==='name')
            {
                set_dialog_value(
                    <div style={{display:'flex',flexDirection:'column',gap:'20px'}}>
                        <label style={{fontSize:'18px',fontWeight:'500',color:bgr==='black'?'white':'black'}}>Update Name</label>
                        <input style={{fontSize:'18px',color:bgr==='black'?'white':'black'}}></input>
                        <div style={{display:'flex',width:innerwidth<=500?'-webkit-fill-available':'462px',gap:'10px'}}>
                            <button style={{flex:1}}>Save</button>
                            <button style={{flex:1}} onClick={()=> {
                                set_dialog_value('')
                                dialogref.current.close()
                            }}>Cancel</button>
                        </div>
                    </div>
                )
                dialogref.current.showModal()
            }
        })
    },[profile_images])

    return(
        <>
        <div style={{display:loaded==true? 'none':'flex',height:'100dvh',justifyContent:'center',alignItems:'center',width:'auto'}}>
            <svg style={{position:'fixed',justifySelf:'center'}} width="100" height="100" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" >
              <rect width="512" height="512" rx="120" fill="#0F172A"></rect>
              <path d="M100 150L150 360L256 210L362 360L412 150" fill="none" stroke="#22C55E" stroke-width="38" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>   
            <label style={{color:'green',fontWeight:'bold',fontSize:'30px',margin:'auto 0px 30px 0px'}}>WhatsUpp</label>     
        </div>
        <div className='home' style={{display:loaded==true? 'flex':'none'}}>
            <div className='top' style={{background:bgr,display:innerwidth<=1100 && disp!=='flex'?'flex':'none',borderBottom:profile_section==='flex' || settings_section==='flex'?'1px gray solid':'none'}}>
                <label style={{color:bgr==='white'?'green':'white'}}> {disp_chat==='flex'?'WhatsUpp':profile_section==='flex'?'Profile':settings_section==='flex'?'Settings':'People'}</label>
            </div>
            <div className='body_section' style={{backgroundColor:bgr}} >
                <div className='desktop_icons'>
                    <app_title style={{display:'flex',gap:'10px',alignItems:'center',margin:'20px 0px 30px 0px',paddingLeft:'30px'}}>
                        <svg width="50" height="50" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" >
                            <rect width="512" height="512" rx="120" fill="#0F172A"></rect>
                            <path d="M100 150L150 360L256 210L362 360L412 150" fill="none" stroke="#22C55E" stroke-width="38" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>   
                        <a style={{color:bgr==='black'?'white':'green',fontWeight:'bold',fontSize:'30px'}}>WhatsUpp</a>     
                    </app_title>
                    <label onClick={()=>set_menu('chat')} style={{color:menu==='chat'?bgr==='black'?'white':'#000000cc':'gray'}}><i style={{background:menu==='chat'?'linear-gradient(180deg,green 70%,darkgreen)':'gray',color:'white',borderRadius:'50%',padding:'10px'}} class='fas fa-comment-dots'></i> Read Chats {unread===0?'':`( ${unread} )`}</label>
                    <label onClick={()=>set_menu('profile')} style={{color:menu==='profile'?bgr==='black'?'white':'#000000cc':'gray'}}><i style={{background:menu==='profile'?'linear-gradient(180deg,green 70%,darkgreen)':'gray',color:'white',borderRadius:'50%',padding:'10px',width:'18px',textAlign:'center'}}  class='fas fa-user'></i> Update Profile</label>
                    <label onClick={()=>set_menu('settings')} style={{color:menu==='settings'?bgr==='black'?'white':'#000000cc':'gray'}}><i style={{background:menu==='settings'?'linear-gradient(180deg,green 70%,darkgreen)':'gray',color:'white',borderRadius:'50%',padding:'10px'}} class='fas fa-cog'></i> Alter Settings</label>
                    <label style={{marginBottom:'20px',marginTop:'auto',color:menu==='log_out'?bgr==='black'?'white':'#000000cc':'gray'}} onClick=
                    {()=>{set_menu('log_out');localStorage.removeItem('logged_in');nav2('/');}} 
                    ><i style={{background:menu==='log_out'?'linear-gradient(180deg,green 70%,darkgreen)':'gray',color:'white',borderRadius:'50%',padding:'10px'}} class='fas fa-solid fa-sign-out-alt'></i> Log Out</label>
                </div>
                <div className='main_body_section'>
                    <label  id="profile_name" style={{display:disp,background:bgr,width:innerwidth>1100 && document.getElementsByClassName('main_body_section')[0]?main_body_section_width+'px':'100%'}}>
                        <i style={{marginLeft:'10px',color:bgr==='black'?'white':'#000000cc'}} onClick={()=>{setdisp('none');set_disp_chat('flex');}} className='fas fa-solid fa-arrow-left'></i>
                        <img src={receiver===up_user?profile_pic: profile_images[indices.indexOf(receiver)]}></img>
                        <label style={{display:'flex',flexDirection:'column',gap:'5px',margin:'10px 0px',alignSelf:'flex-start',height:'50px',justifyContent:'center'}}>
                            <label style={{color:bgr==='black'?'white':'#000000cc',fontWeight:'500',fontSize:'18px',alignSelf:'flex-start'}}>{info[indices.indexOf(receiver)*2]===profile?`${profile}🟣`:info[indices.indexOf(receiver)*2] }</label> 
                            <label style={{color:bgr==='black'?'#aaa':'#555',fontWeight:'normal',fontSize:'17px',alignSelf:'flex-start',visibility:status[indices.indexOf(receiver)]===''?'hidden':'visible'}}>{receiver===index?live_status==='true'?status[indices.indexOf(receiver)]:'':status[indices.indexOf(receiver)]}</label>
                        </label>
                    </label>
                    <div className='chat_detail_section' style={{display:disp}} >
                        {messages.map((value,index)=>
                        {
                            if(receiver==messages[index][0])
                            {
                                return(
                                    <div key={index} className='chat_detail' style={{display:'flex',flexDirection:'column'}} >
                                        {value[1].map((text,ind)=>
                                        (
                                            text.startsWith('✔')?
                                            (<span style={{gap:'3px',whiteSpace:'pre-line',marginRight:'10px',display:'flex',flexDirection:'column', overflowWrap:'break-word',marginTop:'10px', alignSelf:'flex-end',backgroundColor:'green',color:'white',borderRadius:'10px',maxWidth:'370px',padding:'5px 10px',fontSize:'18px'}}>
                                                <select id='options1' value={selectval} onChange={(e)=>
                                                    { 
                                                    if(e.target.value==='Delete'){set_edit('none'); set_msg_value('');set_reply('none');set_reply_to('');delete_msg(receiver,text);}
                                                    else if(e.target.value==='Edit'){set_reply('none');set_reply_to('');edit_msg(receiver,text);}
                                                    else if(e.target.value==="Reply"){set_edit('none');set_msg_value('');reply_msg(receiver,text);}
                                                    else{set_edit('none');set_msg_value('');set_reply('none');set_reply_to('');}
                                                    set_selectval('Select')}}
                                                        style={{marginBottom:'auto',marginLeft:'auto',width:'16px',height:'8px',
                                                            border:'none',background:'white',borderRadius:'50%'
                                                        }}>
                                                    <option value='Select'></option>
                                                    <option value='Edit'>Edit</option>
                                                    <option value='Delete'>Delete</option>
                                                    <option value='Reply'>Reply</option>
                                                    <option value='seen'>{!msg_attributes[index]?.[ind]?.seen_info?'Not Seen':msg_attributes[index]?.[ind]?.seen_info}</option>
                                                </select>
                                                <span onClick={()=> find_qouted_msg(text)}
                                                    style={{cursor:'pointer',display:!msg_attributes[index]?.[ind]?.reply_info?.[0]?"none":msg_attributes[index][ind].reply_info[0],width:'260px',flexDirection:'column',padding:'5px',borderRadius:'10px',backgroundColor:'#18b018'}}>
                                                    <span style={{fontWeight:'bold'}}>{!msg_attributes[index]?.[ind]?.reply_info?.[1]?'':msg_attributes[index][ind].reply_info[1]}</span>
                                                    <span style={{textOverflow:'ellipsis',overflowX:'hidden',whiteSpace:'nowrap',fontSize:'18px'}}>{!msg_attributes[index]?.[ind]?.reply_info?.[2]?'':msg_attributes[index][ind].reply_info[2]}</span>
                                                </span>
                                                <span style={{paddingRight:'15px',minWidth:'auto',maxWidth:innerwidth>500?'370px':'270px'}}>{find_url( text.slice(0,text.lastIndexOf(' ')).replace(text.slice(0,text.indexOf(' ')),''))}</span>
                                                <span style={{paddingLeft:'15px',fontSize:'10px',marginLeft:'auto',marginTop:'auto',display:'flex',alignItems:'end'}}>{!msg_attributes[index]?.[ind]?.edit_info?'':(<d style={{marginRight:'5px'}}>{msg_attributes[index][ind].edit_info}</d>)} {new Date(text.slice(text.lastIndexOf(' ')+1,text.length)).toLocaleTimeString()} {
                                                    text.startsWith('✔✔')?
                                                    (
                                                    <>
                                                       <svg width="12" height="12" viewBox="0 0 16 15" fill="none" style={{minHeight:'12px',minWidth:'12px',marginLeft:'5px'}}>
                                                        <path
                                                            d="M1.5 8L5.5 12L14.5 2"
                                                            stroke={text.startsWith('✔✔✔✔')?'deepskyblue':'darksalmon'}
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        </svg> 
                                                        <svg width="12" height="12" viewBox="0 0 16 15" fill="none" style={{minHeight:'12px',minWidth:'12px'}}>
                                                        <path
                                                            d="M1.5 8L5.5 12L14.5 2"
                                                            stroke={text.startsWith('✔✔✔✔')?'deepskyblue':'darksalmon'}
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        </svg> 
                                                    </>
                                                    ):
                                                    (
                                                        <svg width="12" height="12" viewBox="0 0 16 15" fill="none" style={{minHeight:'12px',minWidth:'12px',marginLeft:'5px'}}>
                                                        <path
                                                            d="M1.5 8L5.5 12L14.5 2"
                                                            stroke={text.startsWith('✔✔✔✔')?'deepskyblue':'darksalmon'}
                                                            strokeWidth="2"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                        </svg> 
                                                    )}</span>
                                            </span>):
                                            text.startsWith(' ')?
                                            (<span style={{whiteSpace:'pre-line',marginLeft:'10px',display:'flex',flexDirection:'column', overflowWrap:'break-word',marginTop:'10px', alignSelf:'flex-start',backgroundColor:bgr==='black'?'darkorchid':'rebeccapurple',color:'white',borderRadius:'10px',maxWidth:'370px',padding:'5px 10px',fontSize:'18px',gap:'3px'}}>
                                                <select id='options2' value={selectval} onChange={(e)=>
                                                    { 
                                                    if(e.target.value==="Reply"){reply_msg(receiver,text);}
                                                    else{set_reply('none');set_reply_to('')}
                                                    set_selectval('Select')}}
                                                        style={{marginBottom:'auto',marginLeft:'auto',width:'16px',height:'8px',
                                                            border:'none',background:'white',borderRadius:'50%'
                                                        }}>
                                                    <option value='Select'></option>
                                                    <option value='Reply'>Reply</option>
                                                </select>
                                                <span onClick={()=> find_qouted_msg(text)}
                                                    style={{cursor:'pointer',display:!msg_attributes[index]?.[ind]?.reply_info?.[0]?'none':msg_attributes[index][ind].reply_info[0],width:'260px',flexDirection:'column',padding:'5px',borderRadius:'10px',backgroundColor:'mediumpurple'}}>
                                                    <span style={{fontWeight:'bold'}}>{!msg_attributes[index]?.[ind]?.reply_info?.[1]?'':msg_attributes[index][ind].reply_info[1]}</span>
                                                    <span style={{textOverflow:'ellipsis',overflowX:'hidden',whiteSpace:'nowrap',fontSize:'18px'}}>{!msg_attributes[index]?.[ind]?.reply_info?.[2]?'':msg_attributes[index][ind].reply_info[2]}</span>
                                                </span>
                                                <span style={{minWidth:'auto', maxWidth:innerwidth>500?'370px':'270px',paddingRight:'15px'}}>{find_url(text.slice(0,text.lastIndexOf(' ')))}</span>
                                                <span style={{paddingLeft:'15px',fontSize:'10px',marginLeft:'auto',marginTop:'auto'}}>{!msg_attributes[index]?.[ind]?.edit_info?'':msg_attributes[index][ind].edit_info} {new Date(text.slice(text.lastIndexOf(' ')+1,text.length)).toLocaleTimeString()}</span>
                                            </span>):
                                            (<span style={{alignSelf:'center', marginTop:'10px',backgroundColor:bgr==='black'?'darkorchid':'rebeccapurple',color:'white',borderRadius:'10px',padding:'5px 10px'}}>{text}</span>) 
                                        )
                                        )}
                                    </div>
                                )
                            }
                        })}
                    </div>
                    <div className='chats' style={{display:disp_chat}}>
                        <a ><aa style={{background:bgr==='white'?'#dfdfdf':'#333'}}><i style={{color:bgr==='white'?'#000000cc':'white'}} className='fas fa-solid fa-search'></i><input style={{background:bgr==='white'?'#dfdfdf':'#333',color:bgr==='white'?'#000000cc':'white'}} id='search_chats' placeholder='Search chat with people  '></input></aa></a>
                        <aaa>
                            <label style={{cursor:'pointer',background: chat_filter==='all'?'linear-gradient(180deg,green 70%,darkgreen)':'white',color: chat_filter==='all'?'white':'gray',border:chat_filter==='all'?'1px solid green':'1px solid gray'}} onClick={()=>set_chat_filter('all')}>All</label>
                            <label style={{cursor:'pointer',background: chat_filter==='unread'?'linear-gradient(180deg,green 70%,darkgreen)':'white',color: chat_filter==='unread'?'white':'gray',border:chat_filter==='unread'?'1px solid green':'1px solid gray'}} onClick={()=>set_chat_filter('unread')}>Unread {unread===0?'':unread}</label>
                        </aaa>
                        {messages.map((value,index)=>
                            {
                                return(
                                    <div onClick={(e)=>{
                                        if(e.target.tagName!=='IMG'){set_seen(value[0]);set_disp_chat('none');setdisp('flex');receiver_again.current=value[0];update_receiver(value[0]);}
                                        }} className='chat_bar' key={index} style={{display:chat_filter==='all'?'flex':value[2]>0?'flex':'none',flexDirection:'row',alignItems:'center',marginBottom:index===messages.length-1?'15px':'0px'}} >
                                        <img style={{flexShrink: '0',borderRadius:'50%',width:'50px',height:'50px',objectFit:'cover',margin:'0 10px'}} src={value[0]===up_user?profile_pic: profile_images[indices.indexOf(value[0])]}></img>
                                        <div style={{marginRight:'10px',display:'flex',flexDirection:'column',height:'60px',minWidth:'0'}}>    
                                            <div style={{height:'30px',fontWeight:'bold',alignItems:'center'}}>
                                                <span style={{color:bgr==='black'?'white':'black',fontWeight:'500'}}>{ info[indices.indexOf(value[0])*2]===profile?`${profile}🟣`:info[indices.indexOf(value[0])*2]}</span>
                                                <span style={{color:bgr==='black'?'#aaa':'#555',fontSize:'12px',marginLeft:'auto',overflow:'visible',whiteSpace:'nowrap',fontWeight:'normal '}}>
                                                    {new Date(value[1][value[1].length-1].slice(value[1][value[1].length-1].lastIndexOf(' ')+1,value[1][value[1].length-1].length)).toLocaleDateString()=== new Date().toLocaleDateString()?
                                                    new Date(value[1][value[1].length-1].slice(value[1][value[1].length-1].lastIndexOf(' ')+1,value[1][value[1].length-1].length)).toLocaleTimeString():
                                                    new Date(value[1][value[1].length-1].slice(value[1][value[1].length-1].lastIndexOf(' ')+1,value[1][value[1].length-1].length)).toLocaleDateString()}
                                                </span>
                                            </div>
                                            <div style={{height:'30px',alignItems:'center'}}>
                                                {status[indices.indexOf(value[0])]==="(Typing...)"?'':
                                                value[1][value[1].length-1].startsWith('✔✔')?
                                                (<>
                                                    <svg width="15" height="15" viewBox="0 0 16 15" fill="none" style={{minHeight:'15px',minWidth:'15px',marginTop:'1px'}}>
                                                    <path
                                                        d="M1.5 8L5.5 12L14.5 2"
                                                        stroke={value[1][value[1].length-1].startsWith('✔✔✔✔')?'deepskyblue':'darksalmon'}
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    </svg>
                                                    <svg width="15" height="15" viewBox="0 0 16 15" fill="none" style={{marginRight:'5px',minHeight:'15px',minWidth:'15px',marginTop:'1px'}}>
                                                    <path
                                                        d="M1.5 8L5.5 12L14.5 2"
                                                        stroke={value[1][value[1].length-1].startsWith('✔✔✔✔')?'deepskyblue':'darksalmon'}
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    </svg>
                                                </>):
                                                value[1][value[1].length-1].startsWith('✔')?
                                                (<svg width="15" height="15" viewBox="0 0 16 15" fill="none" style={{marginRight:'5px',minHeight:'15px',minWidth:'15px',marginTop:'1px'}}>
                                                <path
                                                    d="M1.5 8L5.5 12L14.5 2"
                                                    stroke={value[1][value[1].length-1].startsWith('✔✔✔✔')?'deepskyblue':'darksalmon'}
                                                    strokeWidth="2"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                                </svg>):''}
                                                <span style={{fontWeight:'normal',color:status[indices.indexOf(value[0])]==="(Typing...)"?bgr==='black'?'lime':'green':bgr==='black'?'#aaa':'#555',fontWeight:status[indices.indexOf(value[0])]==="(Typing...)"?'bold':'normal',fontSize:'17px'}}>{status[indices.indexOf(value[0])]==="(Typing...)"?"Typing...": value[1][value[1].length-1].slice(value[1][value[1].length-1].indexOf(' '),value[1][value[1].length-1].lastIndexOf(' '))}</span>
                                                <span style={{borderRadius:'50%',color:'white',backgroundColor:'green',marginLeft:'auto',fontWeight:'bold',padding:value[2]===0?'0': '1px 5px 0px 5px'}}>{value[2]==0?"":value[2]}</span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                    <div className='profile_section' style={{display:profile_section}} >
                        <div style={{background:bgr}}>
                            <img style={{flexShrink: '0',borderRadius:'50%',width:'150px',height:'150px',objectFit:'cover'}} src={profile_pic}></img>
                            <div style={{display:'flex',flexDirection:'row',margin:'10px 0px 30px 0',padding:'0',gap:'30px'}}>
                            <label className='waiting_loader' style={{
                                    display:updating_pic?'block':'none',width:'20px',height:'20px',borderRadius:'50%',border:'5px white solid',borderTop:'5px #000000cc solid'
                            }}></label>
                                <input type="file" id='fileInput' hidden  
                                onChange={(e)=>
                                {
                                    if(e.target.files[0].type.startsWith('image'))
                                    {
                                        let form=new FormData() 
                                        form.append('file',e.target.files[0])
                                        form.append('token',token)
                                        form.append('previous_dp',profile_pic)
                                        set_updating_pic(true)
                                        fetch('/upload_pic',{
                                            method:'POST',
                                            body:form
                                        })
                                        .then(res=>res.json())
                                        .then(data=>
                                        {
                                            set_updating_pic(false)
                                            if(data.url)
                                            {
                                                set_profile_pic(data.url)
                                            }
                                        })
                                    }
                                }
                                }></input>
                                <label onClick={()=>document.getElementById('fileInput').click()} style={{display:updating_pic?'none':'block',cursor:'pointer',color:bgr==='black'?'white':'#000000cc',margin:'0',width:'auto'}}><i className='fas fa-solid fa-cloud-upload-alt'></i></label>
                                <label onClick={(e)=>
                                    {
                                        set_updating_pic(true)
                                        fetch('/remove_pic',{
                                            method:'POST',
                                            headers:{'Content-Type':'application/json'},
                                            body:JSON.stringify({token:token,public_id:profile_pic.slice(profile_pic.lastIndexOf('/')+1,profile_pic.lastIndexOf('.'))})
                                        })
                                        .then(res=>res.json())
                                        .then(data=>{
                                            set_updating_pic(false)
                                            if(data.success){set_profile_pic('dp.png')}
                                        })
                                    }
                                } style={{cursor:'pointer', color:bgr==='black'?'white':'#000000cc', display:profile_pic!=='dp.png' && !updating_pic?'flex':'none'}}><i style={{margin:'0',width:'auto'}} className='fas fa-solid fa-trash-alt'></i></label>
                                
                            </div>
                            <label style={{color:bgr==='black'?'white':'#000000cc',marginBottom:'10px',display:'flex',width:'-webkit-fill-available'}}><i className='fas fa-envelope'></i>Email</label>
                            <label style={{color:bgr==='black'?'#aaa':'#555',fontWeight:'normal',marginBottom:'30px'}}>{up_user}</label>
                            <label style={{color:bgr==='black'?'white':'#000000cc',marginBottom:'10px',display:'flex',width:'-webkit-fill-available'}}><i className='fas fa-user-circle'></i>Name <i style={{marginRight:'0',marginLeft:'auto',width:'auto'}}
                            id='name' className='fas fa-solid fa-pen'></i></label>
                            <label style={{color:bgr==='black'?'#aaa':'#555',fontWeight:'normal',marginBottom:'30px'}}>{up_name}</label>
                            <label style={{color:bgr==='black'?'white':'#000000cc',marginBottom:'10px',display:'flex',width:'-webkit-fill-available'}}><i className='fas fa-solid fa-address-card'></i>About <i style={{marginRight:'0',marginLeft:'auto',width:'auto'}} id='about' className='fas fa-solid fa-pen'></i></label>
                            <label style={{color:bgr==='black'?'#aaa':'#555',fontWeight:'normal',overflowWrap:'anywhere',paddingRight:'20px',whiteSpace:'pre-line'}}>{up_bio}</label>
                        </div>
                    </div>
                    <div className='settings_section' style={{display:settings_section}} >
                        <div>
                            <img style={{flexShrink: '0',borderRadius:'50%',width:'150px',height:'150px',objectFit:'cover'}} src={profile_pic}></img>
                            <label style={{color:bgr==='black'?'white':'#000000cc',marginTop:'30px',display:'flex',width:'-webkit-fill-available'}}>
                                <i style={{width:'31px'}} className='fas fa-solid fa-signal'></i>
                                Active Status 
                                <label onClick={async ()=>{
                                    if(live_status==='true')
                                    {
                                        let online_status=ref(real_time_db,`online_status/${nameatfirst}`)
                                        await update(online_status,{display:'false'})
                                        set_live_status('false')}
                                    else
                                    {
                                        let online_status=ref(real_time_db,`online_status/${nameatfirst}`)
                                        await update(online_status,{display:'true'})
                                        set_live_status('true')
                                    }
                                }} style={{display:'flex',borderRadius:'20px',height:'20px',width:'40px',padding:'5px',marginLeft:'auto',background:live_status==='true'?'green':'gray',cursor:'pointer',justifyContent:live_status==='true'?'end':'start',transition:'.5s ease-in-out'}}>
                                    <label style={{borderRadius:'20px',height:'20px',width:'20px',background:'white',cursor:'pointer',transition:'.5s ease-in-out'}}></label>
                                </label> 
                            </label>
                            <label style={{color:bgr==='black'?'#aaa':'#555',fontWeight:'normal',marginBottom:'30px'}}>{live_status==='true'?'Display':'Hide'}</label>
                            <label style={{color:bgr==='black'?'white':'#000000cc',display:'flex',width:'-webkit-fill-available'}}><i style={{width:'29px',fontSize:'20px'}} className='fas fa-solid fa-sun'></i> Light Theme 
                                <label onClick={()=>{
                                    fetch('/save_settings', {
                                        method: 'POST',
                                        headers: {
                                            'Content-Type': 'application/json',
                                        },
                                        body: JSON.stringify({ token: token,bg: bgr==='white'?'black':'white' }),
                                    })
                                    .then(response => response.json())
                                    .then(data=>
                                    {
                                        if(bgr==='white')
                                        {setbg('black')}
                                        else{setbg('white')}
                                    })
                                    }} style={{display:'flex',borderRadius:'20px',height:'20px',width:'40px',padding:'5px',marginLeft:'auto',background:bgr==='white'?'green':'gray',cursor:'pointer',justifyContent:bgr==='white'?'end':'start',transition:'.5s ease-in-out'}}>
                                    <label style={{borderRadius:'20px',height:'20px',width:'20px',background:'white',cursor:'pointer',transition:'.5s ease-in-out'}}></label>
                                </label>
                            </label>
                            <label style={{color:bgr==='black'?'#aaa':'#555',fontWeight:'normal',marginBottom:'30px'}}>{bgr==='white'?'ON':'OFF'}</label>
                            <label style={{color:'red',marginBottom:'30px'}}><i style={{width:'28px',fontSize:'20px'}} className='fas fa-solid fa-lock'></i>Change Password </label>
                            <label onClick={()=>{localStorage.removeItem('logged_in');nav2('/')}} style={{color:'red'}}><i style={{width:'29px',fontSize:'20px'}} className='fas fa-solid fa-sign-out-alt'></i>Log Out </label>
                        </div>
                    </div>
                </div>
                <div className='people_section' style={{display:innerwidth>1100?'flex':menu==='people'?'flex':'none'}} >
                    <span id="youmayknow" style={{fontWeight:'bold', justifySelf:'center', alignSelf:'center',color:bgr==='black'?'white':'#000000cc'}}><i style={{marginRight:'5px'}} id="refresh_people" class="fas fa-sync fa-alt"></i> You may know!</span>
                    <aa >
                        <aaa style={{background:bgr==='white'?'#dfdfdf':'#333'}}>
                            <i style={{color:bgr==='white'?'#000000cc':'white',padding:'10px'}} class="fas fa-solid fa-search"></i>
                            <input placeholder='Search for people' value={search_value} 
                            onChange={(e)=>
                                {
                                    if(e.target.value[0]===' '){e.target.value=e.target.value.substring(1)}
                                    if(e.target.value.length>15){e.target.value=e.target.value.slice(0,15)}
                                    set_search_value(e.target.value.replace(/[^a-zA-Z_]/g, ''))
                                }}
                            style={{background:bgr==='white'?'#dfdfdf':'#333',width:innerwidth>500?'auto':'-webkit-fill-available',placeSelf:'center',borderRadius:'20px',border:'none',fontSize:'16px',padding:'10px',color:bgr==='white'?'#000000cc':'white'}}></input>
                        </aaa>
                    </aa>
                    <span id='no_match' style={{display:no_match_msg, color:bgr==='black'?'#aaa':'#555',alignSelf:'center',fontWeight:'bold'}}>No match found</span>
                    {info.map((a, index) => {
                        if (index < info.length / 2) {
                            w = w + 1; 
                            return (
                                <div className='userinfo' key={index} style={{display:search_filter[index]}}> 
                                    <div style={{display:search_filter[index]}}>
                                        <img src={up_user===indices[index]?profile_pic: profile_images[index]}></img>
                                        <span style={{display:'flex',flexDirection:'column',justifyContent:'center',gap:'10px',paddingRight:'10px',minWidth:'0'}}>
                                            <span style={{fontWeight:'500',color:bgr==='black'?'white':'#000000cc'}} className='connect_people' >{info[index + w ]}{status[index]==='(Online)' || status[index]==='(Typing...)'?'🟢':''}</span> 
                                            <span style={{fontWeight:'normal',fontSize:'17px',color:bgr==='black'?'#aaa':'#555',textOverflow:'ellipsis',overflowX:'hidden',whiteSpace:'nowrap'}}>{info[index + w + 1]}</span>
                                        </span>
                                        <button onClick={()=>
                                            {
                                                set_menu('chat')
                                                update_receiver(indices[index])
                                                receiver_again.current=indices[index]
                                                set_seen(indices[index])
                                            }
                                        } className='connect_buttons'><i className='fas fa-comment-dots'></i></button>
                                    </div>
                                </div>
                            );
                        }
                        return null; 
                    })}
                </div>
            </div>
            <div className='msg_div' style={{display:disp,background:reply_to.length>0 || msg_before_edit.length>0?'green':'white',left:innerwidth>1100 && document.getElementsByClassName('main_body_section')[0]?(main_body_section_width/2)-221.11+270+'px':'auto'}}>
                <span style={{display:reply_to.length>0 || msg_before_edit.length>0?'flex':'none',flexDirection:'column',backgroundColor:'green',color:'white'}}>
                    <label style={{marginLeft:'auto',cursor:'pointer',paddingRight:'11px',fontWeight:'bold',paddingTop:'5px'}} onClick={()=>{if(reply_icon==="flex"){set_reply('none');set_reply_to('')}if(edit_icon==="flex"){set_msg_value('');set_edit('none');set_text('');document.getElementById('Send_Button').style.backgroundColor='#EEEEEE';document.getElementById('message').style.height='46px'}}}>{reply_to.length>0?<i className='fas fa-solid fa-reply'></i>:msg_before_edit.length>0?<i className='fas fa-solid fa-pen'></i>:''}<i className="fas fa-times"></i></label>
                    <label style={{paddingBottom:'5px',paddingLeft:'10px',overflowX:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}><label style={{fontWeight:'bold'}}>{msg_before_edit.length>0?'You : ':reply_to.length>0?reply_to.startsWith('✔')?'You : ':`${info[indices.indexOf(receiver)*2]} : `:''}</label><label>{reply_to.length>0?reply_to.slice(reply_to.indexOf(' ')+1,reply_to.lastIndexOf(' ')-4):msg_before_edit.length>0?msg_before_edit.slice(msg_before_edit.indexOf(' ')+1,msg_before_edit.lastIndexOf(' ')-4):''}</label></label>
                </span>
                <div style={{border:reply_to.length>0 || msg_before_edit.length>0?'1px solid green':'1px solid gray',background:bgr==='black'?'#333':'white'}}>
                    <textarea id="message" ref={focus_input} value={message_text} style={{ scrollbarWidth:'none',resize:"none",height:'46px',maxHeight:'85px',background:bgr==='black'?'#333':'white',color:bgr==='black'?'white':'#000000cc'}} placeholder='Type...'
                    onKeyDown={(e)=>
                    {
                        set_consecutive_keys(previous_keys=>
                        {
                            let previous_array=[...previous_keys]
                            if(previous_array.length<2)
                            {
                                previous_array.push(e.key)
                            }
                            else{
                                previous_array.splice(0,1)
                                previous_array.push(e.key)
                            }
                            return previous_array
                        })
                        if(e.key==='Enter')
                        {
                            if(consecutive_keys[1]==='Shift')
                            {
                                document.getElementById('message').scrollTop=document.getElementById('message').scrollHeight
                                return
                            }
                            else if(message_text.length>0)
                            {
                                e.preventDefault()
                                set_text('')
                                document.getElementById('message').style.height='46px'
                                document.getElementById('Send_Button').style.backgroundColor='#EEEEEE'
                                edit_icon==='flex'?write_edit(message_text):Send(message_text)
                            }
                        }
                    }}
                    onChange={(e)=>
                    {
                        e.target.style.height='auto';
                        e.target.style.height=e.target.scrollHeight+'px';
                        e.target.value=e.target.value.replace(/^\s+/, "");
                        set_text(e.target.value)
                        if(e.target.value==='')
                        {
                            document.getElementById('Send_Button').style.backgroundColor='#EEEEEE'
                        }
                        else{document.getElementById('Send_Button').style.backgroundColor='lime'}
                        typing_status()
                    }
                    }></textarea>
                    <button id="Send_Button" style={{color:'white',margin:'10px',borderRadius:'7px'}}
                        onClick={()=>{
                        focus_input.current.focus()
                        if(message_text!='')
                        {
                        if(edit_icon==='none'){Send(message_text)};
                        if(edit_icon==='flex'){write_edit(message_text)}
                        set_text('')
                        set_consecutive_keys([])
                        document.getElementById('message').style.height='46px'
                        document.getElementById('Send_Button').style.backgroundColor="#EEEEEE"}}} ><i className='fas fa-arrow-up'></i></button>
                </div>
            </div>
            <div className='phone_icons' style={{display:innerwidth<=1100 && disp==='none'?'flex':'none' ,backgroundColor:bgr==='black'?'black':'white'}}>
                <label onClick={()=>set_menu('chat')} style={{color:menu==='chat'?bgr==='black'?'white':'#000000cc':'gray'}}><i style={{padding:'10px',borderRadius:'50%',color:'white',background:menu==='chat'?'linear-gradient(180deg, green 70%, darkgreen)':'gray',width:'auto'}} class='fas fa-comment-dots'><sup> {unread===0?'':unread}</sup></i> Chats</label>
                <label onClick={()=>set_menu('profile')} style={{color:menu==='profile'?bgr==='black'?'white':'#000000cc':'gray'}}><i style={{padding:'10px',borderRadius:'50%',color:'white',background:menu==='profile'?'linear-gradient(180deg, green 70%, darkgreen)':'gray'}} class='fas fa-user'></i> Profile</label>
                <label onClick={()=>set_menu('settings')} style={{color:menu==='settings'?bgr==='black'?'white':'#000000cc':'gray'}}><i style={{padding:'10px',borderRadius:'50%',color:'white',background:menu==='settings'?'linear-gradient(180deg, green 70%, darkgreen)':'gray'}} class='fas fa-cog'></i> Settings</label>
                <label onClick={()=>set_menu('people')} style={{color:menu==='people'?bgr==='black'?'white':'#000000cc':'gray'}} id="people"><i style={{padding:'10px 7px',borderRadius:'50%',color:'white',width:'auto',background:menu==='people'?'linear-gradient(180deg, green 70%, darkgreen)':'gray'}} class='fas fa-users'></i> People</label>
            </div>
        </div>
        <dialog style={{border:'2px gray solid',borderBottomWidth:innerwidth<=500?'0px':'2px',borderRadius:innerwidth>500?'20px':'40px 40px 0 0',top:innerwidth<=500?'auto':'revert',width:innerwidth<=500?'-webkit-fill-available':'fit-content'}} ref={dialogref}>{dialog_value}</dialog>
        </>
    );
}
export default Home;
